import { render, staticRenderFns } from "./ProductReleases.vue?vue&type=template&id=47fac794"
import script from "./ProductReleases.vue?vue&type=script&lang=js"
export * from "./ProductReleases.vue?vue&type=script&lang=js"
import style0 from "./ProductReleases.vue?vue&type=style&index=0&id=47fac794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports